module.exports = __webpack_public_path__ + "img/1.c2ab4416.jpg";